export const THEME_MODE_VALUE_KEY = 'kt_theme_mode_value'

export const THEME_MODE_MENU_KEY = 'kt_theme_mode_menu'

export enum ThemeModeEnum {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}
